export default "__VITE_ASSET__DDb$bs8r__"